<article>
  <h1>Return & Exchange Policy</h1>

  <p>
    At Pink Soul, we want you to love your purchase! If you're not completely
    satisfied, we’re here to help. Please review our return and exchange policy
    below.
  </p>

  <h2>Eligibility for Returns</h2>
  <ul>
    <li>
      Items must be returned within <strong>30 days</strong> of the delivery
      date.
    </li>
    <li>
      Items must be in <strong>new, unused, unwashed</strong> condition with
      original tags attached.
    </li>
    <li>
      Final sale items, accessories, and gift cards are
      <strong>non-returnable</strong>.
    </li>
  </ul>

  <h2>How to Start a Return or Exchange</h2>
  <p>
    To initiate a return or exchange, please email our customer service team at
    <a href="mailto:support@pinksoul.us">support&#64;pinksoul.us</a> with the
    following information:
  </p>
  <ul>
    <li>Your order number</li>
    <li>The item(s) you wish to return or exchange</li>
    <li>The reason for your return or exchange</li>
    <li>If exchanging, please include the desired size or item</li>
  </ul>
  <p>
    We will respond within 1-2 business days with instructions on how to
    proceed.
  </p>

  <h2>Return Shipping</h2>
  <p>
    Customers are responsible for return shipping costs. We recommend using a
    trackable shipping method as we are not responsible for lost or damaged
    return packages.
  </p>

  <h2>Refunds</h2>
  <ul>
    <li>
      Refunds will be issued to the original payment method within
      <strong>5–10 business days</strong> after we receive your return.
    </li>
    <li>Shipping costs are <strong>non-refundable</strong>.</li>
  </ul>

  <h2>Exchanges</h2>
  <p>
    Exchanges are subject to product availability. We’ll notify you once your
    exchange has been processed and shipped.
  </p>

  <h2>Damaged or Incorrect Items</h2>
  <p>
    If you received a damaged or incorrect item, please contact us within
    <strong>7 days</strong> of receiving your order with a photo and description
    of the issue. We will resolve the matter promptly.
  </p>

  <h2>Contact Us</h2>
  <p>
    For all return and exchange inquiries, please reach out to us at
    <a href="mailto:support@pinksoul.us">support&#64;pinksoul.us</a>.
  </p>

  <p>Thank you for shopping with Pink Soul!</p>
</article>
